var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refuseInvitation defatult-bg"},[_c('div',{staticClass:"text"},[(_vm.status)?[_vm._v("\n      感谢您对高毅资产的信任和支持，"),_c('br'),_vm._v("我们期待您的莅临！\n    ")]:[_vm._v("\n      感谢您对高毅资产的信任和支持！\n    ")]],2),_c('footer-message',{staticStyle:{"color":"#fff"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }